<div class="container mt-4 home-page">
  <div class="topNavH"></div>
  <div class="text-end mb-3">
    <app-settings-offcanvas></app-settings-offcanvas>
  </div>

  <div class="card mb-4 shadow-sm">
    <div class="card-body">
      <div *ngIf="isLoadingSchoolInfo && !schoolDetailsError" class="text-center p-2">
        <div class="spinner-border spinner-border-sm text-secondary-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span class="ms-2">{{ 'HOME.LOADING_SCHOOL_INFO_GENERIC' | translate }} (Name/Address)</span>
      </div>
      <div *ngIf="schoolDetailsError && !isLoadingSchoolInfo" class="alert alert-danger small p-2">
        {{ schoolDetailsError }}
      </div>
      <div *ngIf="!isLoadingSchoolInfo && !schoolDetailsError">
        <div class="row mb-2">
          <div class="col-12 fw-bold">
            {{ 'HOME.SCHOOL_NAME_LABEL' | translate }}：<span class="fw-normal">{{ schoolInfo.name }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 fw-bold">
            {{ 'HOME.RIDING_SCHOOL_LABEL' | translate }}：<span class="fw-normal">{{ schoolInfo.ridingSchool }}</span>
          </div>
        </div>
      </div>

      <!-- <hr *ngIf="(!isLoadingSchoolInfo || !schoolDetailsError) || (!isLoadingTermInfo || !termInfoError)"> -->
      <div class="p-1"></div>
      <div *ngIf="isLoadingTermInfo && !termInfoError" class="text-center p-2 ">
        <div class="spinner-border spinner-border-sm text-secondary-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span class="ms-2">{{ 'HOME.LOADING_TERM_DETAILS' | translate }} (Dates/Term Name)</span>
      </div>
      <div *ngIf="termInfoError && !isLoadingTermInfo" class="alert alert-warning small p-2">
        {{ termInfoError }}
      </div>
      <div *ngIf="!isLoadingTermInfo && !termInfoError">
        <div class="row mb-2">
          <div class="col-12 fw-bold">
            {{ 'HOME.ASSIGNED_DATES_TIME' | translate }}：<span class="fw-normal">{{ schoolInfo.assignedWeekday }}</span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 fw-bold">
            {{ 'HOME.ASSIGNED_TIMESLOT_LABEL' | translate }}：<span class="fw-normal">{{ schoolInfo.assignedDates
              }}</span>
          </div>
        </div>
        <!-- <div class="row mb-2">
          <div class="col-12 fw-bold">
            {{ 'HOME.ASSIGNED_TIMESLOT_LABEL' | translate }}：<span class="fw-normal">{{ schoolInfo.assignedTimeslot }}</span>
            </div>
        </div> -->

      </div>
    </div>
  </div>

  <div class="p-2">
    <h2 class="mb-4 mt-5 text-center bigTitleCol">{{ 'HOME.SCHOOL_CONSENT_TITLE' | translate }}</h2>

    <p class="text-muted mb-2" [class.clickable-link]="termTncFileFullUrl"
      (click)="termTncFileFullUrl && downloadTncFile()"
      [title]="termTncFileFullUrl ? ('HOME.CLICK_TO_VIEW_TNC' | translate) : null">
      {{ 'HOME.TERM_RIDE_CONDITIONS_SUBTITLE' | translate }}<span
        class="underline-text">{{'HOME.TERMS_AND_CONDITIONS_TEXT'| translate }}</span>
    </p>

    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="schoolConsentCheck" [(ngModel)]="schoolConsentChecked"
        (ngModelChange)="consentChanged()">
      <label class="form-check-label" for="schoolConsentCheck">
        {{ 'HOME.CONSENT_CHECKBOX_LABEL' | translate }}
      </label>
    </div>
    <div *ngIf="showConsentError" class="text-danger mt-3 small consent-error-message text-center">
      {{ 'HOME.ERROR_CONSENT_REQUIRED' | translate }}
    </div>
    <div class="alert alert-warning text-center small p-2 mt-5">
      {{ 'HOME.TNC_CONFIRMATION_NOTE' | translate }}
    </div>
    <div class="text-center mt-5 button-wrapper" (click)="handleConsentCheckOnClick()">
      <button class="btn button-primary-purple btn-lg" (click)="onAddNewStudentProfile()"
        [disabled]="!schoolConsentChecked">
        {{ 'HOME.ADD_NEW_STUDENT_PROFILE_BUTTON' | translate }}
      </button>
    </div>
   
  </div>
</div>